import _ from "lodash";

export default _.mapKeys([
	"FETCH_SECTION_REQUEST",
	"FETCH_SECTION_FINISHED",
	"SET_CURRENT_SECTION_INDEX",
	"SET_SECTION",
	"SAVE_FIELD_LOCALLY",
	"EMPTY_SAVED_LOCAL_DATA"
]);
